import $ from 'jquery'
import { STORAGE_KEY } from './define';
import { CHAT_TYPE } from '../myComponents/Chatframe';
export function getVuxUrlQuery (url){            //获取当前url
    var dz_url = url.split('#')[0];                //获取#/之前的字符串
    var cs = dz_url.split('?')[1];                //获取?之后的参数字符串
    var cs_arr = cs.split('&');                    //参数字符串分割为数组
    var cs={};
    for(var i=0;i<cs_arr.length;i++){         //遍历数组，拿到json对象
      cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1]
    }
    console.log('url query',cs)
    return cs
}
export function  getUrlParams (url) {
    console.log('get url param',url)
    let result = {};
    const arr_= url.split('?')
    if(arr_.length<=1){
        return result
    }
    const paramArr = arr_[1].split('&')
    for(let i=0;i<paramArr.length;++i){
        const _arr = paramArr[i].split('=')
        if(_arr.length==2){
            result[_arr[0]]=_arr[1]
        }
    }
    return result
}
// 请求数据
export function postData(type, url, data,callback){
    $.ajax({
        type: type,
        url: url,
        data: data,
        success(res){
            callback(res);
        }
    })
}

export function createRequest(method,api,data,callback){
    let token = localStorage.getItem(STORAGE_KEY.TOKEN);
    if(!data) {
        data ={}
    }
    data.access_token = token;
    let tokenData = data
    // console.log('process',process.env)
    $.ajax({
        type: method,
        url: process.env.VUE_APP_API_APPLET_URL +'/'+api,
        data: tokenData,
        success(res){
            callback(res);
        },
        error: function (errorMsg) {
            //请求失败时执行该函数
            console.log(errorMsg,'请求数据失败')
            // alert("请求数据失败!",errorMsg);
            callback({
                code:errorMsg.status,
                msg:errorMsg.statusText
            })
        }
    })
}

export function makeBase64(url){
   return window.btoa(window.encodeURIComponent(url));
}

export function paseBase64(base64){
    return window.decodeURIComponent(window.atob(base64));
}

/**
 * 获取聊天附件的类型
 */
export function getChatFileType(url){
    if(!url){
        return 
    }
    let ex = url.substring(url.lastIndexOf('.')+1)
    ex = ex.toLowerCase()
    if(['png','jpg','jpeg'].indexOf(ex)>=0){
        return CHAT_TYPE.IMG
    }
    else if(['mp4'].indexOf(ex)>=0){
        return CHAT_TYPE.VIDEO
    }
    else if(['pdf'].indexOf(ex)>=0){
        return CHAT_TYPE.FILE
    }
    return 
}

export function base64ToBlob(base64,fileType){
    let typeHeader = 'data:application/' + fileType + ';base64,'; // 定义base64 头部文件类型
    let audioSrc = typeHeader + base64; // 拼接最终的base64
    let arr = audioSrc.split(',');
    let array = arr[0].match(/:(.*?);/);
    let mime = (array && array.length > 1 ? array[1] : type) || type;
    // 去掉url的头，并转化为byte
    let bytes = window.atob(arr[1]);
    // 处理异常,将ascii码小于0的转换为大于0
    let ab = new ArrayBuffer(bytes.length);
    // 生成视图（直接针对内存）：8位无符号整数，长度1个字节
    let ia = new Uint8Array(ab);
    for (let i = 0; i < bytes.length; i++) {
    ia[i] = bytes.charCodeAt(i);
    }
    return new Blob([ab], {
    type: mime
    });

}


// WEBPACK FOOTER //
// ./src/utils/utils.js